var setUpload = function () {
    $(".editor-selection .btn-upload").addClass("active");
    $(".editor-selection .btn-editor").removeClass("active");
    $('button[id="edit-design-button"]').each(function (index) {
        $(this).hide()
    });

    $('button[id="add-basket-button"]').each(function (index) {
        $(this).show()
    });
    $('#editor-flag-input').val(0);
    $('#attachments_card').show();
}

var setEditor = function () {
    $(".editor-selection .btn-editor").addClass("active");
    $(".editor-selection .btn-upload").removeClass("active");
    $('button[id="add-basket-button"]').each(function (index) {
        $(this).hide()
    });
    $('button[id="edit-design-button"]').each(function (index) {
        $(this).show()
    });
    $('#editor-flag-input').val(1);
    $('#attachments_card').hide();
}

// execute the function when the page loads
$(document).ready(function () {
    if ($('#editor-flag-input').val() === "1") {
        setEditor();
    } else {
        setUpload();
    }
});

$(".editor-selection .btn-upload").click(setUpload);
$(".editor-selection .btn-editor").click(setEditor);

$('#nav_menu .nav-link').on('click', function () {
    setTimeout(function () {
        $('#nav_menu .nav-link').each(function () {
            if (!$(this).siblings(".submenu").hasClass("show")) {
                $(this).addClass("collapsed");
            }
        })
    }, 500);
});

document.addEventListener("wishlist-content-loaded", function (e) {
    $('.add-wishlist-button').click(function (e) {
        var that = $(this);
        var inputForm = "";
        $.ajax({
            type: 'POST',
            url: '/add_to_wishlist/' + that.data("id"),
            success: function (data) {
                that.hide();
                that.siblings('.remove-wishlist-button').show();
                that.siblings('.added-wishlist-alert').show();

                var savedAlert = $(".saved-alert")
                savedAlert.show();
            }
        });
    });

    $('.remove-wishlist-button').click(function (e) {
        var that = $(this);
        $.ajax({
            type: 'POST',
            url: '/remove_from_wishlist/' + that.data("id"),
            success: function (data) {
                that.hide();
                that.siblings('.add-wishlist-button').show();

                var removedAlert = $(".removed-wishlist-alert")
                removedAlert.show();
            }
        });
    });
});

$('.add-saved-configuration-button').click(function (e) {
    var that = $(this);
    that.prop("disabled", true);
    var inputForm = "";
    var description = "";
    var jobName = "";
    if ($('#PrintData').length) {
        var printData = JSON.parse($("#PrintData").val());
        inputForm = printData.inputForm;
        description = printData.descrizione;
    }

    if ($('#job_name').length) {
        jobName = $('#job_name').val();
    }
    $.ajax({
        type: 'POST',
        url: '/add_to_saved_configuration/' + that.data("id"),
        data: {
            "inputForm": inputForm,
            "description": description,
            "jobName": jobName
        },
        success: function () {
            var savedAlert = $(".added-saved-configuration-alert")
            savedAlert.show();
            that.prop("disabled", false);
        }
    });
});
$(".added-saved-configuration-alert .btn-close").on('click', function (e) {
    $(".added-saved-configuration-alert").hide();
    e.preventDefault();
})

$('.print-product-quote-button').click(function (e) {
    var that = $(this);
    $("#form-product-quote-print").submit();
});

$('.download-pdf-button').click(function (e) {
    var that = $(this);
    var ttpdfParams = {};
    var slugTitle = '';

    if ($('#PrintData').length) {
        var printData = JSON.parse($("#PrintData").val() || '');
        ttpdfParams = printData.outputData.ttpdfParams;

        const productDescObj = printData.descrizione.find((el) => el.nome == 'Prodotto');
        const baseDescObj = printData.descrizione.find((el) => el.nome == 'Scegli un Formato (Base)');
        const altezzaDescObj = printData.descrizione.find((el) => el.nome == 'Scegli un Formato (Altezza)');
        const formatoDescObj = printData.descrizione.find((el) => el.nome == 'Formato');

        let title = `${productDescObj.valore}`;

        if (baseDescObj && altezzaDescObj) {
            title += ` ${baseDescObj.valore} x ${altezzaDescObj.valore}`;
        } else if (formatoDescObj) {
            title += ` ${formatoDescObj.valore}`;
        }

        slugTitle = title.toLowerCase().replace(/ /g, "-").replace(/[^\w-]+/g, "");
    }

    $.ajax({
        type: 'POST',
        url: '/products/download_pdf',
        data: {
            "ttpdfParams": ttpdfParams
        },
        success: function (response) {
            var blob = new Blob([response], {type: 'application/pdf'});
            const blobUrl = URL.createObjectURL(blob);

            // Create a link element
            const link = document.createElement("a");

            // Set link's href to point to the Blob URL
            link.href = blobUrl;
            link.download = `${slugTitle}.pdf`;

            // Append link to the body
            document.body.appendChild(link);

            // This is necessary as link.click()
            link.dispatchEvent(
                new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                })
            );

            // Remove link from body
            document.body.removeChild(link);
        }
    })
        .fail(function (response) {
            if (!response.success) {
                console.error('error', response.error);
                var errorAlert = $(".error-download-pdf-alert")
                errorAlert.show();
            }
        });
});

function checkModal(modalId) {
    if ($("#" + modalId).length) {
        return $("#" + modalId);
    } else {
        return $(document.body);
    }
}

$(document).ready(function () {
    var customAdapter = $.fn.select2.amd.require('select2/data/customAdapter');
    if ($("#repository_code").length) {
        $("#repository_code").select2({
            theme: "bootstrap4",
            minimumResultsForSearch: 1,
            dataAdapter: customAdapter,
            allowClear: true,
            dropdownParent: checkModal("repository-modal"),
            placeholder: function () {
                $(this).data('placeholder');
            },
        });
    }
});

$(window).on("formLoaded", (event) => {
    var tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    const list = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    list.map((el) => {
        let opts = {
            animation: false,
        }
        if (el.hasAttribute('data-bs-content-id')) {
            opts.content = document.getElementById(el.getAttribute('data-bs-content-id')).innerHTML;
            opts.html = true;
        }
        new bootstrap.Popover(el, opts);
    })

    $(window).on("refreshPopoverGrid", (event) => {
        var elements = document.querySelectorAll('[id^="popover-taglia"]');
        elements.forEach(function (element) {
            var dataBsContentId = element.getAttribute('data-bs-content-id');
            const popover = bootstrap.Popover.getOrCreateInstance('#' + element.id);
            popover.setContent({
                '.popover-body': document.getElementById(dataBsContentId).innerHTML
            });
        });
    });
});

$('#add-basket-button.punto_market').click(function (e) {

    const headers = {
        "Accept": "application/json",
        "Content-Type": "application/json"
    };
    try {
        $('#add-basket-button.punto_market').prop("disabled", true);
        $(".print-form").attr("action", "/add_to_basket_punto_market");
        $(".print-form").submit();
    } finally {
        $('#add-basket-button.punto_market').prop("disabled", false);
    }
});

